import * as Constants from "../constants";

export const getCurrentWithoutRelationshipsUser = () => ({
  type: Constants.GET_CURRENT_WITHOUT_RELATIONSHIPS_USER,
});

export const getCurrentWithoutRelationshipsUserSuccess = (data) => ({
  type: Constants.GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_SUCCESS,
  payload: data,
});

export const getCurrentWithoutRelationshipsUserError = (error) => ({
  type: Constants.GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_ERROR,
  error,
});

export const getCurrentUserJWT = (id) => ({
  type: Constants.GET_CURRENT_USER_JWT,
  id,
});

export const getCurrentUserJWTSuccess = (data) => ({
  type: Constants.GET_CURRENT_USER_JWT_SUCCESS,
  payload: data,
});

export const getCurrentUserJWTError = (error) => ({
  type: Constants.GET_CURRENT_USER_JWT_ERROR,
  error,
});
